/* -----------------------------------------------------------------------------
 * Dkhoun — Arabic search augmentation
 *
 * بيضيف نتايج تحت نتايج شوبيفاي، ما بيستبدلهاش أبدًا. شوبيفاي بيفضل مصدر
 * الحقيقة للبحث العادي (العنوان، SKU، البائع، التاجات)، والطبقة دي بتغطّي
 * فجوتين متحقَّق منهما بالاختبار على المتجر:
 *
 *   1. الشكل العربي لاسم العطر الأصلي (custom.inspired_by_name) — غايب
 *      تمامًا من أي حقل شوبيفاي بيبحث فيه.
 *   2. استبدال حرف وقلب حرفين — شوبيفاي ما بيتسامحش معاهم.
 *
 * شوبيفاي بالفعل بيوحّد الهمزات والتاء المربوطة وبيتسامح مع حرف ناقص، فمفيش
 * داعي نعيد عمل ده — الطي العدواني هنا بيخدم المطابقة المحلية بس.
 *
 * Augments, never replaces. If anything here fails the layer disables itself
 * and the theme behaves exactly as it does today.
 *
 * Spec: docs/superpowers/specs/2026-08-11-arabic-search-augmentation-design.md
 * -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SCHEMA = 2;
  var TTL_MS = 60 * 60 * 1000;
  var MAX_LOCAL = 3;
  var MAX_CANDIDATES = 12;
  var MIN_SCORE = 55;
  var DEBUG =
    (window.Shopify && window.Shopify.designMode) ||
    /[?&]dk_search_debug=1/.test(location.search);

  function log() {
    if (DEBUG && window.console) console.log.apply(console, ['[dk-search]'].concat([].slice.call(arguments)));
  }

  /* ===========================================================================
   * 1. Transliteration — Latin name to a set of plausible Arabic spellings.
   *
   * بيرجّع مجموعة احتمالات مش احتمال واحد. النقل من الفرنساوي مالوش إجابة
   * واحدة صح: Sauvage ممكن تتكتب سوفاج أو سافاج، والاتنين بيتكتبوا فعلاً.
   *
   * مرفوض صراحة: قاعدة "الحرف الساكن الأخير يتشال". دي بتكسر Chanel
   * وGuerlain وأغلب الأسماء الفرنسية. الصامت الوحيد اللي بيتشال هو e في
   * آخر الكلمة، وده سلوك فرنسي حقيقي مش قاعدة عامة.
   *
   * Returns a SET of candidates. Never one answer — French transliteration
   * has no single correct form. The only silent drop is a terminal `e`.
   * ======================================================================== */
  var DIGRAPHS = [
    ['cqu', ['ك']],
    ['tion', ['شن']],
    ['cc', ['ك']],
    ['aa', ['ا']],
    ['eau', ['و']],
    ['eux', ['و']],
    ['ough', ['و']],
    ['eu', ['و']],
    ['oeu', ['و']],
    ['ou', ['و']],
    ['au', ['و', 'ا']],
    ['oi', ['وا']],
    ['ai', ['ي', 'ا']],
    ['ei', ['ي']],
    ['ee', ['ي']],
    ['oo', ['و']],
    ['ch', ['ش']],
    ['sh', ['ش']],
    ['ph', ['ف']],
    ['th', ['ث', 'ت']],
    ['gh', ['غ']],
    ['gn', ['ني']],
    ['qu', ['ك']],
    ['ck', ['ك']],
    ['ss', ['س']],
    ['ll', ['ل']],
    ['tt', ['ت']],
    ['mm', ['م']],
    ['nn', ['ن']],
    ['rr', ['ر']],
    ['ff', ['ف']],
    ['pp', ['ب']]
  ];

  var SINGLES = {
    a: ['ا'], b: ['ب'], d: ['د'], f: ['ف'], h: ['ه'], i: ['ي'],
    j: ['ج'], k: ['ك'], l: ['ل'], m: ['م'], n: ['ن'], o: ['و'],
    p: ['ب'], q: ['ك'], r: ['ر'], s: ['س'], t: ['ت'], u: ['و', 'ا'],
    v: ['ف'], w: ['و'], x: ['كس'], y: ['ي'], z: ['ز'], e: ['ي']
  };

  function softVowelNext(word, i) {
    var n = word.charAt(i + 1);
    return n === 'e' || n === 'i' || n === 'y';
  }

  function translitWord(word) {
    var out = [''];
    var i = 0;

    while (i < word.length) {
      var produced = null;
      var consumed = 1;

      for (var d = 0; d < DIGRAPHS.length; d++) {
        var pat = DIGRAPHS[d][0];
        if (word.substr(i, pat.length) === pat) {
          produced = DIGRAPHS[d][1];
          consumed = pat.length;
          break;
        }
      }

      if (!produced) {
        var ch = word.charAt(i);
        if (ch === 's' && word.charAt(i + 1) === 'c' && softVowelNext(word, i + 1)) {
          produced = ['س'];
          consumed = 2;
        } else if (ch === 'c') {
          // c قبل e/i/y بتبقى س، وغير كده ك — قاعدة مشروطة مش عامة.
          produced = softVowelNext(word, i) ? ['س'] : ['ك'];
        } else if (ch === 'g') {
          produced = softVowelNext(word, i) ? ['ج'] : ['ج', 'غ'];
        } else if (ch === 'o' && i === 0) {
          produced = ['أو', 'او'];
        } else if ((ch === 'e' || ch === 'i') && i === 0) {
          // حرف علة في أول الكلمة بياخد ألف قبله في النطق العربي:
          // Eros تتكتب ايروس مش يروس.
          produced = ch === 'e' ? ['اي', 'ي'] : ['اي', 'ي'];
        } else if (ch === 'e' && i === word.length - 1 && word.length > 2) {
          // الـ e الأخيرة صامتة في الفرنساوي — الحالة الوحيدة اللي بنشيل فيها.
          produced = [''];
        } else {
          produced = SINGLES[ch] || [''];
        }
      }

      var next = [];
      for (var a = 0; a < out.length; a++) {
        for (var b = 0; b < produced.length; b++) {
          next.push(out[a] + produced[b]);
          if (next.length >= MAX_CANDIDATES) break;
        }
        if (next.length >= MAX_CANDIDATES) break;
      }
      out = next;
      i += consumed;
    }

    return out;
  }

  // الحروف المشكّلة لازم تترد لأصلها الأول، وإلا Giò بتتقص لـ "gi" وتطلع
  // "جي" بدل "جيو". Normalise accents first or Giò truncates to "gi".
  // كلمات نطقها العربي مستقر ومفيش قاعدة حروف توصّلّه.
  // مقصودة تفضل صغيرة جدًا: دي مش قايمة أسماء، دي استثناءات لغوية.
  // acqua/aqua: قاعدة qu عامة بتديها "ك" وهي صح للفرنساوي (Jacques)، فالتغيير
  // العام كان هيكسر أسماء تانية — الاستثناء هنا على مستوى الكلمة مش الحرف.
  //
  // Words whose Arabic form is settled and no letter rule reaches. Deliberately
  // tiny — these are linguistic exceptions, not a name lookup. Changing the
  // global `qu` rule would break French names that genuinely sound like ك.
  var WORD_MAP = {
    acqua: ['أكوا', 'اكوا'],
    aqua: ['أكوا', 'اكوا'],
    million: ['مليون'],
    the: ['ذا', 'ذي'],
    de: ['دي', 'دو'],
    eau: ['و', 'أو']
  };

  // الأرقام كانت بتتشال بالكامل، فـ 9PM كانت بتبقى pm ثم "بم".
  // بنولّد الرقم العربي والنطق الإنجليزي — العميل ممكن يكتب أي واحد فيهم.
  // Digits were being stripped entirely, so 9PM became pm then "بم". Emit both
  // the Arabic-Indic numeral and the spoken English form.
  var DIGITS = {
    '0': ['٠', 'زيرو'], '1': ['١', 'وان'], '2': ['٢', 'تو'],
    '3': ['٣', 'ثري'],  '4': ['٤', 'فور'], '5': ['٥', 'فايف'],
    '6': ['٦', 'سيكس'], '7': ['٧', 'سفن'], '8': ['٨', 'ايت'],
    '9': ['٩', 'ناين']
  };

  // أسماء الحروف اللاتينية — للاختصارات المكتوبة كابيتال زي PM في 9PM.
  var LETTER_NAMES = {
    a:'ايه', b:'بي', c:'سي', d:'دي', e:'اي', f:'اف', g:'جي', h:'اتش',
    i:'اي', j:'جيه', k:'كيه', l:'ال', m:'ام', n:'ان', o:'او', p:'بي',
    q:'كيو', r:'ار', s:'اس', t:'تي', u:'يو', v:'في', w:'دبليو',
    x:'اكس', y:'واي', z:'زد'
  };

  function deaccent(s) {
    return String(s)
      .normalize ? String(s).normalize('NFD').replace(/[\u0300-\u036f]/g, '') : String(s);
  }

  function transliterate(latin) {
    if (!latin) return [];

    // نفصل الأرقام عن الحروف (9PM -> 9 | PM) ونحافظ على الحالة الأصلية
    // عشان نعرف الاختصارات الكابيتال قبل ما نصغّر.
    var raw = deaccent(latin)
      .replace(/[^A-Za-z0-9\s'-]/g, ' ')
      .replace(/(\d)([A-Za-z])/g, '$1 $2')
      .replace(/([A-Za-z])(\d)/g, '$1 $2')
      .split(/[\s'-]+/)
      .filter(Boolean);
    if (!raw.length) return [];

    var combos = [''];
    for (var w = 0; w < raw.length; w++) {
      var token = raw[w];
      var lower = token.toLowerCase();
      var forms;

      if (/^\d+$/.test(token)) {
        // رقم: بنولّد الشكلين لو خانة واحدة، وغير كده الرقم العربي زي ما هو.
        if (token.length === 1 && DIGITS[token]) {
          forms = DIGITS[token].slice();
        } else {
          var arabicNum = '';
          for (var g = 0; g < token.length; g++) {
            arabicNum += (DIGITS[token.charAt(g)] || [token.charAt(g)])[0];
          }
          forms = [arabicNum, token];
        }
      } else if (WORD_MAP[lower]) {
        forms = WORD_MAP[lower].slice();
      } else if (token.length <= 3 && token === token.toUpperCase() && /^[A-Z]+$/.test(token)) {
        // اختصار كابيتال (PM, XS): بيتنطق حرف حرف.
        var spelled = '';
        for (var c = 0; c < lower.length; c++) spelled += (c ? ' ' : '') + (LETTER_NAMES[lower.charAt(c)] || '');
        forms = [spelled.trim()].concat(translitWord(lower));
      } else {
        forms = translitWord(lower);
      }
      var next = [];
      for (var c = 0; c < combos.length; c++) {
        for (var f = 0; f < forms.length; f++) {
          next.push((combos[c] ? combos[c] + ' ' : '') + forms[f]);
          if (next.length >= MAX_CANDIDATES) break;
        }
        if (next.length >= MAX_CANDIDATES) break;
      }
      combos = next;
    }

    // تنظيف: "ابيييده" -> "ابيده". تكرار الألف/الواو/الياء مالوش معنى في
    // العربي، وأي حرف متكرر تلات مرات غلط أكيد.
    // Collapse vowel runs — Arabic does not repeat ا/و/ي, and any letter
    // appearing three times is always a transliteration artefact.
    combos = combos.map(function (c) {
      return c.replace(/([اوي])\1+/g, '$1').replace(/(.)\1\1+/g, '$1');
    });

    var seen = {}, uniq = [];
    for (var u = 0; u < combos.length; u++) {
      var v = combos[u].trim();
      if (v && !seen[v]) { seen[v] = 1; uniq.push(v); }
    }
    return uniq;
  }

  /* ===========================================================================
   * 2. Matching — normalise, rank, and gate.
   *
   * التطبيع طبقتين: خفيف بيدّي مطابقة كاملة القوة، وعدواني (طي الهمزات
   * والتاء المربوطة) بيدّي درجة أقل — عشان المطابقة الحقيقية تسبق المطوية.
   *
   * Two-tier normalisation so a true match always outranks a folded one.
   * ======================================================================== */
  var TASHKEEL = /[ً-ْـ]/g;

  function normLight(s) {
    return String(s || '')
      .toLowerCase()
      .replace(TASHKEEL, '')
      .replace(/[^؀-ۿa-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normFold(s) {
    return normLight(s)
      .replace(/[أإآٱ]/g, 'ا')
      .replace(/ة/g, 'ه')
      .replace(/ى/g, 'ي')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي');
  }

  // Damerau-Levenshtein مع خروج مبكر لما المسافة تعدّي الحد.
  function editDistance(a, b, max) {
    var al = a.length, bl = b.length;
    if (Math.abs(al - bl) > max) return max + 1;
    var prev2 = [], prev = [], cur = [], i, j;
    for (j = 0; j <= bl; j++) prev[j] = j;
    for (i = 1; i <= al; i++) {
      cur[0] = i;
      var best = cur[0];
      for (j = 1; j <= bl; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          cur[j] = Math.min(cur[j], prev2[j - 2] + cost);
        }
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      prev2 = prev.slice();
      prev = cur.slice();
    }
    return prev[bl];
  }

  // عتبات القبول — الترتيب لوحده مش كفاية، لازم المطابقة تستاهل أصلاً.
  function fuzzyAllowed(len) {
    if (len <= 3) return 0;   // ممنوع fuzzy على التوكنز القصيرة — بتطلع ضوضاء
    if (len <= 5) return 1;
    return 2;
  }

  function scoreToken(qTok, hayTokens, hayFold) {
    var best = 0, i;
    for (i = 0; i < hayTokens.length; i++) {
      var h = hayTokens[i];
      if (h === qTok) return 95;   // token exact — أقل من التطابق الكامل (100)
      if (h.indexOf(qTok) === 0) best = Math.max(best, 80);
      // الاستعلام بيمدّ التوكن بحرف أو اتنين. التوكن لازم يكون ٤ حروف على
      // الأقل، وإلا كلمة زي "هير" (من her) بتخطف "هيرود" — ده حصل فعلاً في
      // الاختبار قبل ما نضيّق الشرط.
      // The query extends the token by at most two characters, and the token
      // must be at least four. Without both guards "هير" (from "her") hijacks
      // "هيرود" — observed in testing, not hypothetical.
      else if (qTok.indexOf(h) === 0 && h.length >= 4 && qTok.length - h.length <= 2) {
        best = Math.max(best, 72);
      }
      else if (h.indexOf(qTok) > -1) best = Math.max(best, 70);
    }
    if (best >= 75) return best;

    var maxD = fuzzyAllowed(qTok.length);
    if (maxD > 0) {
      for (i = 0; i < hayTokens.length; i++) {
        var d = editDistance(qTok, hayTokens[i], maxD);
        if (d <= maxD) {
          var sim = 1 - d / Math.max(qTok.length, hayTokens[i].length);
          if (qTok.length >= 6 && sim < 0.7) continue;
          // لازم يعدّي MIN_SCORE وإلا الـ fuzzy كله كود ميت.
          best = Math.max(best, 68 - (d - 1) * 10);
        }
      }
    }

    if (!best && hayFold.indexOf(qTok) > -1) best = 60;
    return best;
  }

  function scoreAgainst(queryLight, queryFold, haystacks, folded) {
    // haystacks: مصفوفة نصوص مرشّحة (العنوان، الاسم اللاتيني، النقل العربي)
    var best = 0;
    for (var i = 0; i < haystacks.length; i++) {
      var hay = haystacks[i];
      if (!hay) continue;
      var hl = folded ? normFold(hay) : normLight(hay);
      if (!hl) continue;

      if (hl === queryLight) return folded ? 90 : 100;

      var qTokens = queryLight.split(' ').filter(Boolean);
      var hTokens = hl.split(' ').filter(Boolean);
      if (!qTokens.length) continue;

      // كل توكن مهم لازم يطابق حاجة — عشان ما نكررش سلوك شوبيفاي اللي
      // بيطابق "عود" لوحدها ويرجّع نص الكتالوج.
      var total = 0, significant = 0, failed = false;
      for (var t = 0; t < qTokens.length; t++) {
        var tok = qTokens[t];
        var s = scoreToken(tok, hTokens, hl);
        if (tok.length >= 3) {
          significant++;
          if (!s) { failed = true; break; }
        }
        total += s;
      }
      if (failed || !significant) continue;
      var avg = total / qTokens.length;
      if (folded) avg -= 10;
      if (avg > best) best = avg;
    }
    return best;
  }

  function matchProduct(item, queryLight, queryFold) {
    var hay = [item.t, item.n];
    if (item.nar) hay.push(item.nar);
    if (item._tr) hay = hay.concat(item._tr);

    // الاتنين دايمًا. الحساب المشروط كان بيخلّي prefix خفيف (80) يسبق
    // exact مطوي (90) — والعقوبة داخل scoreAgainst كفيلة بالترتيب.
    // Always compute both. Gating the folded pass let a light prefix (80)
    // outrank a folded exact (90); the penalty inside scoreAgainst is what
    // keeps a true match ahead, not skipping the comparison.
    return Math.max(
      scoreAgainst(queryLight, queryFold, hay, false),
      scoreAgainst(queryFold, queryFold, hay, true)
    );
  }

  /* ===========================================================================
   * 3. Index — load, verify, cache.
   *
   * ممنوع كاش جزئي: الفهرس ما بيتخزّنش غير لما كل الصفحات تنجح والعدد يتطابق.
   * لو التحديث فشل وفيه كاش قديم صالح بنكمّل عليه؛ لو مفيش، الطبقة بتتقفل.
   *
   * No partial cache — stored only after every page loads and the count checks
   * out. On refresh failure a valid stale cache keeps serving; with no cache
   * the layer disables itself.
   * ======================================================================== */
  var Index = {
    items: null,
    loading: null,
    byHandle: {},

    key: function () {
      var count = (window.DK_SEARCH_META && window.DK_SEARCH_META.count) || 0;
      var loc = (window.Shopify && window.Shopify.locale) || 'x';
      var mkt = (window.Shopify && (window.Shopify.country || window.Shopify.market)) || 'x';
      return 'dkq:' + SCHEMA + ':' + count + ':' + loc + ':' + mkt;
    },

    read: function () {
      try {
        var raw = localStorage.getItem(this.key());
        if (!raw) return null;
        var box = JSON.parse(raw);
        if (!box || !box.items) return null;
        box.stale = Date.now() - box.at > TTL_MS;
        return box;
      } catch (e) { return null; }
    },

    write: function (items) {
      try {
        localStorage.setItem(this.key(), JSON.stringify({ at: Date.now(), items: items }));
      } catch (e) { log('cache write failed', e); }
    },

    fetchAll: function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var all = [];

      // من غير مهلة، طلب معلّق بيسيب سبينر شغّال للأبد وسلوك الفشل
      // ما بينفّذش أصلاً. Without a timeout a hung request leaves a spinner
      // running forever and the failure path never executes.
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timeout = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);

      function page(n) {
        return fetch(root + 'collections/all?view=dk-index&page=' + n,
                     { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) {
            if (!r.ok) throw new Error('index page ' + n + ' -> ' + r.status);
            return r.text();
          })
          .then(function (txt) {
            var data = JSON.parse(txt);
            if (data.schemaVersion !== SCHEMA) throw new Error('schema mismatch');
            all = all.concat(data.items || []);
            if (n < data.pages) return page(n + 1);
            clearTimeout(timeout);
            // المقارنة مع العدد الطازج من الصفحة كمان، مش مع رد الـ endpoint
            // بس — وإلا فهرس قديم يقدر يصادق على نفسه ويتخزّن تحت مفتاح جديد.
            var fresh = (window.DK_SEARCH_META && window.DK_SEARCH_META.count) || 0;
            if (data.count && all.length !== data.count) {
              throw new Error('count mismatch ' + all.length + '/' + data.count);
            }
            if (fresh && all.length !== fresh) {
              throw new Error('stale index ' + all.length + ' vs page ' + fresh);
            }
            return all;
          });
      }
      return page(1);
    },

    prime: function (items) {
      this.byHandle = {};
      for (var i = 0; i < items.length; i++) {
        items[i]._tr = items[i].n ? transliterate(items[i].n) : [];
        if (items[i].h) this.byHandle[items[i].h] = items[i];
      }
      return items;
    },

    load: function () {
      if (this.items) return Promise.resolve(this.items);
      if (this.loading) return this.loading;

      var self = this;
      var cached = this.read();

      if (cached && !cached.stale) {
        this.items = this.prime(cached.items);
        return Promise.resolve(this.items);
      }

      this.loading = this.fetchAll()
        .then(function (items) {
          self.write(items);
          self.items = self.prime(items);
          log('index loaded', self.items.length);
          return self.items;
        })
        .catch(function (err) {
          log('index failed', err);
          if (cached) {                       // stale-while-revalidate
            self.items = self.prime(cached.items);
            return self.items;
          }
          self.items = [];                    // disable silently
          return self.items;
        });

      // نعرض الكاش القديم فورًا ونحدّث في الخلفية.
      if (cached) {
        this.items = this.prime(cached.items);
        return Promise.resolve(this.items);
      }
      return this.loading;
    },

    search: function (q) {
      if (!this.items || !this.items.length) return [];
      var ql = normLight(q), qf = normFold(q);
      if (ql.length < 2) return [];

      var hits = [];
      for (var i = 0; i < this.items.length; i++) {
        var it = this.items[i];
        if (it.av === false && window.DK_SEARCH_META && window.DK_SEARCH_META.unavailableMode === 'hide') continue;
        var s = matchProduct(it, ql, qf);
        if (s >= MIN_SCORE) hits.push({ item: it, score: s });
      }
      hits.sort(function (a, b) { return b.score - a.score; });
      return hits;
    }
  };

  /* ===========================================================================
   * 4. Rendering + integration
   * ======================================================================== */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function inspiredPrefix() {
    var loc = ((window.Shopify && window.Shopify.locale) || 'ar').toLowerCase();
    return loc.indexOf('en') === 0 ? 'Inspired by' : 'مستوحى من';
  }

  function inspiredMarkup(item) {
    if (!item || !item.n) return '';
    return '<span class="dk-search-inspired" data-dk-search-inspired>' +
             '<span class="dk-search-inspired__prefix">' + esc(inspiredPrefix()) + '</span> ' +
             '<span class="dk-search-inspired__name" dir="auto">' + esc(item.n) + '</span>' +
           '</span>';
  }

  var listboxSeq = 0;

  // نفس بنية snippets/pr-sidebar-loop.liquid عشان الصف المحلي يبقى مطابق.
  function card(it, optionId, position, total) {
    var accessibleName = it.t + (it.n ? ', ' + inspiredPrefix() + ' ' + it.n : '');
    return (
      '<div id="' + optionId + '" class="t4s_complimentary__product t4s-row t4s-space-item-inner t4s-widget__pr"' +
           ' role="option" aria-label="' + esc(accessibleName) + '" aria-selected="false"' +
           ' aria-posinset="' + position + '" aria-setsize="' + total + '"' +
           ' data-dk-search-option>' +
        '<div class="t4s-col-item t4s-col t4s-widget_img_pr">' +
          '<a class="t4s-d-block t4s-pr t4s-oh t4s_ratio t4s-bg-11" href="' + esc(it.u) + '"' +
             ' tabindex="-1" aria-hidden="true" style="--aspect-ratioapt:' + (it.r || 1) + '">' +
            '<img src="' + esc(it.i) + '" alt="' + esc(it.al) + '" loading="lazy">' +
          '</a>' +
        '</div>' +
        '<div class="t4s-col-item t4s-col t4s-widget_if_pr">' +
          '<a href="' + esc(it.u) + '" tabindex="-1" class="t4s-d-block t4s-widget__pr-title">' + esc(it.t) + '</a>' +
          inspiredMarkup(it) +
          (it.p || '') +
        '</div>' +
      '</div>'
    );
  }

  function block(hits, heading, primary) {
    // لما تبقى هي المحتوى الوحيد، الخط الفاصل بيبقى بلا معنى — مفيش حاجة فوقه.
    var cls = 'dk-search-suggest' + (primary ? ' is--primary' : '');
    var id = 'dk-search-listbox-' + (++listboxSeq);
    var headId = id + '-label';
    var html = '<div class="' + cls + '">' +
               '<div id="' + headId + '" class="dk-search-suggest__head">' + esc(heading) + '</div>' +
               '<span class="visually-hidden" role="status" aria-live="polite" aria-atomic="true">' +
                 esc(resultCountText(hits.length)) +
               '</span>' +
               '<div id="' + id + '" role="listbox" aria-labelledby="' + headId + '" data-dk-search-listbox>';
    for (var i = 0; i < hits.length; i++) {
      html += card(hits[i].item, id + '-option-' + (i + 1), i + 1, hits.length);
    }
    return html + '</div></div>';
  }

  function headingText() {
    var loc = ((window.Shopify && window.Shopify.locale) || 'ar').toLowerCase();
    return loc.indexOf('en') === 0 ? 'Suggested results' : 'نتائج مقترحة';
  }

  function resultCountText(count) {
    var loc = ((window.Shopify && window.Shopify.locale) || 'ar').toLowerCase();
    return loc.indexOf('en') === 0
      ? count + ' suggested results available'
      : count + ' نتائج مقترحة متاحة';
  }

  function productHandle(link) {
    if (!link) return '';
    var m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]).toLowerCase(); }
    catch (e) { return m[1].toLowerCase(); }
  }

  function existingHandles(container) {
    var set = {};
    var links = container.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var handle = productHandle(links[i]);
      if (handle) set[handle] = 1;
    }
    return set;
  }

  // Shopify's predictive and full-search HTML cannot expose product metafields.
  // Join those rendered cards to the already-loaded local index by handle and
  // add the original fragrance name without another network request.
  function annotateInspired(root) {
    if (!root || !Index.items || !Index.items.length) return;
    var cards = root.querySelectorAll('.t4s-widget__pr, .t4s-product, .dk-page-card');
    for (var i = 0; i < cards.length; i++) {
      var cardEl = cards[i];
      if (cardEl.querySelector('[data-dk-search-inspired], .dk-card-insp')) continue;

      var link = cardEl.querySelector('a[href*="/products/"]');
      var handle = productHandle(link);
      var item = handle && Index.byHandle[handle];
      if (!item || !item.n) continue;

      var title = cardEl.querySelector('.t4s-widget__pr-title, .t4s-product-title, .dk-page-card__title');
      if (!title) continue;
      title.insertAdjacentHTML('afterend', inspiredMarkup(item));

      if (cardEl.getAttribute('role') === 'option') {
        cardEl.setAttribute('aria-label', item.t + ', ' + inspiredPrefix() + ' ' + item.n);
      }
    }
  }

  function clearPredictiveEmpty(container) {
    if (!container || container.querySelector('.t4s-widget__pr')) return false;
    var removed = false;
    var nodes = container.childNodes;
    for (var i = nodes.length - 1; i >= 0; i--) {
      if (nodes[i].nodeType === 3 && nodes[i].textContent.trim()) {
        container.removeChild(nodes[i]);
        removed = true;
      }
    }
    return removed;
  }

  function prepareCombobox(input) {
    if (!input) return;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-haspopup', 'listbox');
    if (!input.hasAttribute('aria-expanded')) input.setAttribute('aria-expanded', 'false');
    if (!input.hasAttribute('aria-label') && !input.hasAttribute('aria-labelledby')) {
      var loc = ((window.Shopify && window.Shopify.locale) || 'ar').toLowerCase();
      input.setAttribute('aria-label', loc.indexOf('en') === 0 ? 'Search products' : 'البحث عن المنتجات');
    }
  }

  function clearLocalSelection(input, container) {
    if (!input || !container) return;
    var options = container.querySelectorAll('[data-dk-search-option]');
    for (var i = 0; i < options.length; i++) {
      options[i].setAttribute('aria-selected', 'false');
      options[i].classList.remove('is--keyboard-active');
    }
    var active = input.getAttribute('aria-activedescendant') || '';
    if (active.indexOf('dk-search-listbox-') === 0) input.removeAttribute('aria-activedescendant');
    var state = localStateByInput.get(input);
    if (state) state.index = -1;
  }

  function resetLocalCombobox(input, container) {
    if (!input) return;
    prepareCombobox(input);
    clearLocalSelection(input, container);
    var controls = input.getAttribute('aria-controls') || '';
    if (controls.indexOf('dk-search-listbox-') === 0) input.removeAttribute('aria-controls');
    localStateByInput.delete(input);
  }

  function syncLocalCombobox(input, container) {
    if (!input || !container) return;
    prepareCombobox(input);
    var list = container.querySelector('[data-dk-search-listbox]');
    if (!list) return;
    input.setAttribute('aria-controls', list.id);
    localStateByInput.set(input, { list: list, index: -1 });
  }

  function moveLocalSelection(input, direction) {
    var container = resultsFor(input);
    var state = localStateByInput.get(input);
    if (!container || !state || !state.list || !state.list.isConnected) return false;
    var options = state.list.querySelectorAll('[data-dk-search-option]');
    if (!options.length) return false;

    var next = state.index;
    if (direction > 0) next = next >= options.length - 1 ? 0 : next + 1;
    else next = next <= 0 ? options.length - 1 : next - 1;

    // The theme can leave one of its own query suggestions selected. A
    // combobox may expose only one active descendant at a time.
    var scope = input.closest('[data-predictive-search]') || container;
    var selected = scope.querySelectorAll('[aria-selected="true"]');
    for (var s = 0; s < selected.length; s++) {
      selected[s].setAttribute('aria-selected', 'false');
      selected[s].classList.remove('is--keyboard-active');
    }

    for (var i = 0; i < options.length; i++) {
      var active = i === next;
      options[i].setAttribute('aria-selected', active ? 'true' : 'false');
      options[i].classList.toggle('is--keyboard-active', active);
    }
    state.index = next;
    input.setAttribute('aria-activedescendant', options[next].id);
    if (options[next].scrollIntoView) options[next].scrollIntoView({ block: 'nearest' });
    return true;
  }

  function openLocalSelection(input) {
    var state = localStateByInput.get(input);
    if (!state || state.index < 0 || !state.list || !state.list.isConnected) return false;
    var options = state.list.querySelectorAll('[data-dk-search-option]');
    var option = options[state.index];
    var link = option && option.querySelector('a[href]');
    if (!link) return false;
    window.location.assign(link.href);
    return true;
  }

  function renderInto(container, query, input) {
    var old = container.querySelector('.dk-search-suggest');
    if (old) old.parentNode.removeChild(old);
    resetLocalCombobox(input, container);
    if (!query || normLight(query).length < 2) return;

    annotateInspired(container);

    // Predictive Search covers fewer fields than the submitted /search page.
    // A zero here is therefore not proof that the store has no matching
    // products (for example, vendor searches can still match on /search).
    var shopifyEmpty = !container.querySelector('.t4s-widget__pr');
    if (shopifyEmpty) clearPredictiveEmpty(container);

    var hits = Index.search(query);
    if (!hits.length) return;

    var taken = existingHandles(container);
    var fresh = [];
    for (var i = 0; i < hits.length && fresh.length < MAX_LOCAL; i++) {
      if (!taken[String(hits[i].item.h || '').toLowerCase()]) fresh.push(hits[i]);
    }
    if (!fresh.length) return;

    // شوبيفاي بيكتب "لم يتم العثور على منتجات" كنص عارٍ جوه الحاوية مباشرة —
    // من غير عنصر يلفّه، فمفيش selector يمسكه. لما يرجّع صفر وعندنا نتايج،
    // الرسالة بتبقى متناقضة مع اللي تحتها فبنشيل الـ text nodes بنفسنا.
    //
    // Shopify writes its empty-state string as a bare text node directly
    // inside the container, so there is no element to select. When it finds
    // nothing and we do have matches, that message contradicts what sits
    // right below it, so the loose text nodes are removed.
    if (shopifyEmpty) {
      clearPredictiveEmpty(container);
    }

    container.insertAdjacentHTML('beforeend', block(fresh, headingText(), shopifyEmpty));
    syncLocalCombobox(input, container);
    log('suggested', fresh.length, 'for', query, shopifyEmpty ? '(primary)' : '(augmenting)');
  }

  /* خانة البحث بتتحقن بعد تحميل الصفحة — الثيم بيجيب سكشن search-hidden
   * بطلب منفصل أول ما تفتح البحث. يعني وقت DOMContentLoaded مفيش
   * [data-input-search] في الصفحة أصلاً، فأي ربط مباشر بيفشل بصمت.
   *
   * التفويض على document بيحل ده من غير مراقبة الشجرة كلها: الحدث بيطلع
   * لحد document مهما اتحقن العنصر إمتى.
   *
   * The search field is injected later — the theme fetches the search-hidden
   * section on demand, so at DOMContentLoaded there is no [data-input-search]
   * to bind to and direct wiring fails silently. Delegating on document works
   * regardless of when the field appears.
   */
  var inputTimers = new WeakMap();
  var observerByContainer = new WeakMap();
  var localStateByInput = new WeakMap();
  var handledArrowByInput = new WeakMap();

  function resultsFor(input) {
    var scope = input.closest('[data-predictive-search]') || document;
    return scope.querySelector('[data-results-search]');
  }

  function refresh(input) {
    var container = resultsFor(input);
    if (!container) return;
    watch(container, input);
    Index.load().then(function () { renderInto(container, input.value, input); });
  }

  // نتايج شوبيفاي بتتحقن بعد ما الطلب يرجع، فبنعيد الرسم لما الحاوية تتغيّر.
  function watch(container, input) {
    if (!window.MutationObserver) return;
    var current = observerByContainer.get(container);
    if (current) {
      current.input = input;
      return;
    }

    var record = { input: input, timer: null, observer: null };
    record.observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && n.classList && n.classList.contains('dk-search-suggest')) return;
        }
      }
      clearTimeout(record.timer);
      record.timer = setTimeout(function () {
        renderInto(container, record.input.value, record.input);
      }, 80);
    });
    record.observer.observe(container, { childList: true, subtree: true });
    observerByContainer.set(container, record);
  }

  /* =========================================================================
   * 5. صفحة /search
   *
   * العميل بيلاقي "سوفاج" في القائمة المنسدلة، وبعدين يضغط إنتر ويوصل لصفحة
   * فاضية — تناقض واضح قدامه. البلوك ده بيقفل الفجوة دي.
   *
   * شبكة شوبيفاي ما بتتلمسش. النتايج المحلية بتترسم تحتها في حاوية منفصلة،
   * عشان عدّاد النتايج وعدّادات الفلاتر تفضل متسقة مع اللي شوبيفاي لاقاه.
   *
   * Shopify's grid is never touched. Local matches render below it in their
   * own container, so the result count and the facet counts stay consistent
   * with what Shopify actually found.
  * ====================================================================== */
  function currentSearchPageQuery() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var expected = (root + 'search').replace(/\/{2,}/g, '/').replace(/\/$/, '');
    var current = location.pathname.replace(/\/$/, '');
    if (current !== expected) return null;
    var params = new URLSearchParams(location.search);
    var q = params.get('q');
    if (!q || normLight(q).length < 2) return null;

    return q;
  }

  function searchPageQuery() {
    var q = currentSearchPageQuery();
    if (!q) return null;
    var params = new URLSearchParams(location.search);

    // أول صفحة بس — الاقتراحات تحت الصفحة التالتة مالهاش معنى.
    var page = params.get('page');
    if (page && page !== '1') return null;

    // مفيش فلاتر فعّالة. العميل اللي فلتر "متاح فقط" ما ينفعش نوريه اقتراح
    // خارج الفلتر بتاعه.
    var filtered = false;
    params.forEach(function (v, k) { if (k.indexOf('filter.') === 0) filtered = true; });
    if (filtered) return null;

    return q;
  }

  // كارت مبسّط — احتياطي بس، لو ما قدرناش نجيب كارت الثيم الحقيقي.
  function pageCard(it) {
    return '<a class="dk-page-card" href="' + esc(it.u) + '">' +
             '<span class="dk-page-card__media">' +
               '<img src="' + esc(it.i) + '" alt="' + esc(it.al) + '" loading="lazy">' +
             '</span>' +
             '<span class="dk-page-card__title">' + esc(it.t) + '</span>' +
             inspiredMarkup(it) +
             '<span class="dk-page-card__price">' + (it.p || '') + '</span>' +
           '</a>';
  }

  // كروت الثيم بتتحمّل كسول: الصورة الحقيقية في data-src والـsrc فيها
  // placeholder شفاف. المحمّل بيشتغل مرة واحدة وقت تحميل الصفحة، فأي كارت
  // بيتحقن بعد كده بيفضل على الـplaceholder — وده اللي كان بيخلّي الاقتراحات
  // تطلع من غير صور خالص.
  //
  // Theme cards are lazy-loaded: the real URL sits in data-src while src holds
  // a transparent placeholder. The loader runs once at page load, so anything
  // injected afterwards keeps the placeholder — which is why the suggestions
  // rendered with no images at all.
  function activateImages(root) {
    // 1) نسبة الأبعاد مخزّنة في data-style مش style — الثيم بينقلها وقت
    //    التحميل. من غيرها صندوق t4s_ratio مالوش ارتفاع، فصورة تطلع ضخمة
    //    والباقي ينهار.
    var styled = root.querySelectorAll('[data-style]');
    for (var t = 0; t < styled.length; t++) {
      var add = styled[t].getAttribute('data-style');
      if (add) styled[t].setAttribute('style', (styled[t].getAttribute('style') || '') + ';' + add);
    }

    // 2) data-src قالب بينتهي بـ width=1 — المحمّل بيستبدل العرض من
    //    data-widths. نسخه زي ما هو بيدّي صورة بيكسل واحد، وده اللي حصل.
    //
    // The ratio lives in data-style, not style, and data-src is a template
    // ending in width=1 that the loader rewrites from data-widths. Copying
    // either verbatim gives a collapsed box and a one-pixel image.
    function realUrl(u) {
      if (!u || u.indexOf('image_src') > -1) return null;
      return u.replace(/([?&]width=)\d+/, '$1600');
    }

    var imgs = root.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var u = realUrl(imgs[i].getAttribute('data-src'));
      if (u) imgs[i].setAttribute('src', u);
      imgs[i].classList.remove('lazyloadt4s');
      imgs[i].removeAttribute('data-widths');
      imgs[i].removeAttribute('data-sizes');
    }

    var bg = root.querySelectorAll('[data-bgset]');
    for (var b2 = 0; b2 < bg.length; b2++) {
      var bu = realUrl(bg[b2].getAttribute('data-bgset'));
      if (bu) bg[b2].style.backgroundImage = 'url(' + bu + ')';
      bg[b2].classList.remove('lazyloadt4s');
    }
  }

  function initSearchPage() {
    var pageQuery = currentSearchPageQuery();
    if (!pageQuery) return;
    var q = searchPageQuery();

    // الثيم بيرسم t4-suggest-products (اقتراحاته هو) قبل شبكة النتايج، فأخد
    // أول مطابقة كان هيعدّ منتجات الحاوية الغلط ويحقن في المكان الغلط.
    var grid = null;
    var candidates = document.querySelectorAll('.t4s_box_pr_grid, .t4s_box_pr_masonry');
    for (var c = 0; c < candidates.length; c++) {
      if (candidates[c].classList.contains('t4-suggest-products')) continue;
      grid = candidates[c];
      if (grid.querySelector('.t4s-product')) break;
    }

    // لما شوبيفاي يرجّع صفر، الثيم ما بيرسمش حاوية شبكة خالص — بيرسم رسالة
    // "لم يتم العثور" بس. فاشتراط وجود الشبكة كان بيعطّل البلوك في أسوأ حالة
    // بالظبط: البحث اللي مالوش نتيجة، وهي اللي البلوك اتعمل عشانها.
    var emptyBox = document.querySelector('.t4s-no-result-product');
    var emptyState = emptyBox && (emptyBox.closest('.t4s-coll-empty') || emptyBox);
    var anchor = grid || emptyState;
    if (!anchor) return;

    var shopifyCount = grid ? grid.querySelectorAll('.t4s-product').length : 0;
    var mainSection = anchor.closest('[id^="shopify-section-"]');
    var sectionId = mainSection && mainSection.id.replace(/^shopify-section-/, '');

    Index.load().then(function () {
      // The original fragrance belongs on every real Shopify result, including
      // filtered and paginated pages where local augmentation is intentionally
      // disabled.
      if (grid) annotateInspired(grid);

      if (!q || document.querySelector('.dk-search-page-suggest')) return;
      var hits = Index.search(q);
      if (!hits.length) return;

      var taken = grid ? existingHandles(grid) : {};
      var fresh = [];
      for (var i = 0; i < hits.length; i++) {
        if (taken[String(hits[i].item.h || '').toLowerCase()]) continue;
        if (shopifyCount > 0 && hits[i].score < 90) continue;
        fresh.push(hits[i]);
        if (fresh.length >= 3) break;
      }
      if (!fresh.length) return;

      function mount(inner) {
        var html = '<section class="dk-search-page-suggest" aria-label="' + esc(headingText()) + '">' +
                   '<h2 class="dk-search-page-suggest__head">' + esc(headingText()) + '</h2>' +
                   inner + '</section>';
        if (!shopifyCount && emptyState) {
          // `.t4s-d-flex` uses !important, so a plain `style.display = none`
          // loses in the cascade and leaves the contradictory empty-state
          // message visible above valid local results. Hide the whole empty
          // state as well, otherwise its 140px margin and search icon leave a
          // large blank hole before the useful cards.
          emptyState.style.setProperty('display', 'none', 'important');
          emptyState.setAttribute('aria-hidden', 'true');
        }
        anchor.insertAdjacentHTML('afterend', html);
        var live = document.querySelector('.dk-search-page-suggest');
        if (!live) return;
        annotateInspired(live);
        activateImages(live);
        if (window.T4SThemeSP && typeof window.T4SThemeSP.reinitProductGridItem === 'function') {
          window.T4SThemeSP.reinitProductGridItem();
        }
        if (window.jQuery_T4NT) window.jQuery_T4NT('body').trigger('currency:update');
      }

      function fallback() {
        var cards = '';
        for (var i = 0; i < fresh.length; i++) cards += pageCard(fresh[i].item);
        if (cards) mount('<div class="dk-search-page-suggest__fallback">' + cards + '</div>');
      }

      // كارت الثيم الحقيقي بدل تقليده. بنطلب السكشن الحالي مرة واحدة باستعلام
      // product IDs دقيق، وبعدها ناخد الشبكة نفسها بكلاسات الأعمدة بتاعتها.
      // نسخ الكروت وحدها خارج `.t4s-row` هو اللي كان بيفك المقاسات ويخلّي
      // الصورة والنص يترسموا كأنهم تلات أعمدة منفصلة.
      //
      // Fetch the current section once with an exact product-ID query, then
      // preserve the source grid wrapper as well as its cards. The old N+1
      // title searches lost the theme's row context and made each card's media
      // and text behave like unrelated columns.
      if (!sectionId) {
        fallback();
        return;
      }

      var ids = [];
      for (var f = 0; f < fresh.length; f++) {
        if (fresh[f].item.d) ids.push('id:' + fresh[f].item.d);
      }
      if (ids.length !== fresh.length) {
        fallback();
        return;
      }

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'search?type=product&q=' + encodeURIComponent(ids.join(' OR ')) +
                '&sections=' + encodeURIComponent(sectionId);
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var give = setTimeout(function () { if (ctrl) ctrl.abort(); }, 6000);

      fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (parts) {
          clearTimeout(give);
          if (!parts || !parts[sectionId]) throw new Error('missing search section');

          var doc = new DOMParser().parseFromString(parts[sectionId], 'text/html');
          var source = null;
          var grids = doc.querySelectorAll('.t4s_box_pr_grid, .t4s_box_pr_masonry');
          for (var g = 0; g < grids.length; g++) {
            if (!grids[g].classList.contains('t4-suggest-products') && grids[g].querySelector('.t4s-product')) {
              source = grids[g];
              break;
            }
          }
          if (!source) throw new Error('missing product grid');

          var byHandle = {};
          var rendered = source.querySelectorAll('.t4s-product');
          for (var r = 0; r < rendered.length; r++) {
            var link = rendered[r].querySelector('a[href*="/products/"]');
            var handle = productHandle(link);
            if (handle) byHandle[handle] = rendered[r];
          }

          var box = source.cloneNode(false);
          box.removeAttribute('data-contentlm-replace');
          box.classList.remove('isotopet4s');
          box.classList.remove('t4s_box_pr_masonry');
          box.classList.add('t4s_box_pr_grid');
          box.classList.add('dk-search-page-suggest__grid');

          for (var i = 0; i < fresh.length; i++) {
            var card = byHandle[fresh[i].item.h];
            if (card) box.appendChild(card.cloneNode(true));
          }
          if (!box.children.length) throw new Error('no matching product cards');

          mount(box.outerHTML);
          log('search page:', box.children.length, 'real cards in one section request');
        })
        .catch(function (err) {
          clearTimeout(give);
          log('search page card render failed', err);
          fallback();
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSearchPage);
  } else {
    initSearchPage();
  }

  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-input-search]')) {
      prepareCombobox(t);
      Index.load();
      log('index warm-up on focus');
    }
  });

  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-input-search]')) return;
    var container = resultsFor(t);
    clearLocalSelection(t, container);
    clearTimeout(inputTimers.get(t));
    inputTimers.set(t, setTimeout(function () { refresh(t); }, 220));
  });

  // Capture before the theme's own bubbling handler. Its option switcher only
  // knows about `<li>` query suggestions, while our product options are cards.
  document.addEventListener('keydown', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-input-search]')) return;

    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (moveLocalSelection(input, e.key === 'ArrowDown' ? 1 : -1)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        handledArrowByInput.set(input, true);
      }
      return;
    }

    if (e.key === 'Enter' && openLocalSelection(input)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    if (e.key === 'Escape') clearLocalSelection(input, resultsFor(input));
  }, true);

  // The theme also switches options on keyup; suppress the paired event only
  // when our capture handler actually handled that arrow key.
  document.addEventListener('keyup', function (e) {
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-input-search]')) return;
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && handledArrowByInput.get(input)) {
      handledArrowByInput.delete(input);
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // The homepage loads this file on the first search interaction. In that
  // path the focus event may have happened while the network request was in
  // flight, so initialise the already-focused input as soon as the script is
  // ready instead of waiting for a second focus.
  var activeInput = document.activeElement;
  if (activeInput && activeInput.matches && activeInput.matches('[data-input-search]')) {
    prepareCombobox(activeInput);
    Index.load();
  }

  // مكشوفة للاختبار اليدوي من الكونسول.
  window.DkhounSearch = {
    transliterate: transliterate,
    normLight: normLight,
    normFold: normFold,
    editDistance: editDistance,
    index: Index
  };
})();
